import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    data: [],
    loading: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {

    switch (type) {

    case actions.GLOBAL_FETCHED:
        return { ...state, data: payload };

    case actions.TRAINERS_FETCH_LOADING:
        return { ...state, ...payload };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/global/global.reducer.js